const  arr=[
    {
        "name": "Afghanistan",
        "dial_code": "+93",
        "code": "AF",
		"priority": 100
    },
    {
        "name": "Aland Islands",
        "dial_code": "+358",
        "code": "AX",
		"priority": 100
    },
    {
        "name": "Albania",
        "dial_code": "+355",
        "code": "AL",
		"priority": 100
    },
    {
        "name": "Algeria",
        "dial_code": "+213",
        "code": "DZ",
		"priority": 100
    },
    {
        "name": "AmericanSamoa",
        "dial_code": "+1684",
        "code": "AS",
		"priority": 100
    },
    {
        "name": "Andorra",
        "dial_code": "+376",
        "code": "AD",
		"priority": 100
    },
    {
        "name": "Angola",
        "dial_code": "+244",
        "code": "AO",
		"priority": 100
    },
    {
        "name": "Anguilla",
        "dial_code": "+1264",
        "code": "AI",
		"priority": 100
    },
    {
        "name": "Antarctica",
        "dial_code": "+672",
        "code": "AQ",
		"priority": 100
    },
    {
        "name": "Antigua&Barbuda",
        "dial_code": "+1268",
        "code": "AG",
		"priority": 100
    },
    {
        "name": "Argentina",
        "dial_code": "+54",
        "code": "AR",
		"priority": 100
    },
    {
        "name": "Armenia",
        "dial_code": "+374",
        "code": "AM",
		"priority": 100
    },
    {
        "name": "Aruba",
        "dial_code": "+297",
        "code": "AW",
		"priority": 100
    },   
    {
        "name": "Austria",
        "dial_code": "+43",
        "code": "AT",
		"priority": 100
    },
    {
        "name": "Azerbaijan",
        "dial_code": "+994",
        "code": "AZ",
		"priority": 100
    },
    {
        "name": "Bahamas",
        "dial_code": "+1242",
        "code": "BS",
		"priority": 100
    },
    {
        "name": "Bahrain",
        "dial_code": "+973",
        "code": "BH",
		"priority": 100
    },
    {
        "name": "Bangladesh",
        "dial_code": "+880",
        "code": "BD",
		"priority": 100
    },
    {
        "name": "Barbados",
        "dial_code": "+1246",
        "code": "BB",
		"priority": 100
    },
    {
        "name": "Belarus",
        "dial_code": "+375",
        "code": "BY",
		"priority": 100
    },
    {
        "name": "Belgium",
        "dial_code": "+32",
        "code": "BE",
		"priority": 100
    },
    {
        "name": "Belize",
        "dial_code": "+501",
        "code": "BZ",
		"priority": 100
    },
    {
        "name": "Benin",
        "dial_code": "+229",
        "code": "BJ",
		"priority": 100
    },
    {
        "name": "Bermuda",
        "dial_code": "+1441",
        "code": "BM",
		"priority": 100
    },
    {
        "name": "Bhutan",
        "dial_code": "+975",
        "code": "BT",
		"priority": 100
    },
    {
        "name": "Bolivia",
        "dial_code": "+591",
        "code": "BO",
		"priority": 100
    },
    {
        "name": "Bosnia&Herzegovina",
        "dial_code": "+387",
        "code": "BA",
		"priority": 100
    },
    {
        "name": "Botswana",
        "dial_code": "+267",
        "code": "BW",
		"priority": 100
    },
    {
        "name": "Brazil",
        "dial_code": "+55",
        "code": "BR",
		"priority": 100
    },
    {
        "name": "British Indian Ocean",
        "dial_code": "+246",
        "code": "IO",
		"priority": 100
    },
    {
        "name": "Brunei Darussalam",
        "dial_code": "+673",
        "code": "BN",
		"priority": 100
    },
    {
        "name": "Bulgaria",
        "dial_code": "+359",
        "code": "BG",
		"priority": 100
    },
    {
        "name": "Burkina Faso",
        "dial_code": "+226",
        "code": "BF",
		"priority": 100
    },
    {
        "name": "Burundi",
        "dial_code": "+257",
        "code": "BI",
		"priority": 100
    },
    {
        "name": "Cambodia",
        "dial_code": "+855",
        "code": "KH",
		"priority": 100
    },
    {
        "name": "Cameroon",
        "dial_code": "+237",
        "code": "CM",
		"priority": 100
    },
    {
        "name": "Canada",
        "dial_code": "+1",
        "code": "CA",
		"priority": 100
    },
    {
        "name": "Cape Verde",
        "dial_code": "+238",
        "code": "CV",
		"priority": 100
    },
    {
        "name": "Cayman Islands",
        "dial_code": "+ 345",
        "code": "KY",
		"priority": 100
    },
    {
        "name": "Central African",
        "dial_code": "+236",
        "code": "CF",
		"priority": 100
    },
    {
        "name": "Chad",
        "dial_code": "+235",
        "code": "TD",
		"priority": 100
    },
    {
        "name": "Chile",
        "dial_code": "+56",
        "code": "CL",
		"priority": 100
    },  
    {
        "name": "Christmas Island",
        "dial_code": "+61",
        "code": "CX",
		"priority": 100
    },
    {
        "name": "Cocos Islands",
        "dial_code": "+61",
        "code": "CC",
		"priority": 100
    },
    {
        "name": "Colombia",
        "dial_code": "+57",
        "code": "CO",
		"priority": 100
    },
    {
        "name": "Comoros",
        "dial_code": "+269",
        "code": "KM",
		"priority": 100
    },
    {
        "name": "Congo",
        "dial_code": "+242",
        "code": "CG",
		"priority": 100
    },
    {
        "name": "Congo, DR",
        "dial_code": "+243",
        "code": "CD",
		"priority": 100
    },
    {
        "name": "Cook Islands",
        "dial_code": "+682",
        "code": "CK",
		"priority": 100
    },
    {
        "name": "Costa Rica",
        "dial_code": "+506",
        "code": "CR",
		"priority": 100
    },
    {
        "name": "Cote d'Ivoire",
        "dial_code": "+225",
        "code": "CI",
		"priority": 100
    },
    {
        "name": "Croatia",
        "dial_code": "+385",
        "code": "HR",
		"priority": 100
    },
    {
        "name": "Cuba",
        "dial_code": "+53",
        "code": "CU",
		"priority": 100
    },
    {
        "name": "Cyprus",
        "dial_code": "+357",
        "code": "CY",
		"priority": 100
    },
    {
        "name": "Czech Republic",
        "dial_code": "+420",
        "code": "CZ",
		"priority": 100
    },
    {
        "name": "Denmark",
        "dial_code": "+45",
        "code": "DK",
		"priority": 100
    },
    {
        "name": "Djibouti",
        "dial_code": "+253",
        "code": "DJ",
		"priority": 100
    },
    {
        "name": "Dominica",
        "dial_code": "+1767",
        "code": "DM",
		"priority": 100
    },
    {
        "name": "Dominican Republic",
        "dial_code": "+1849",
        "code": "DO",
		"priority": 100
    },
    {
        "name": "Ecuador",
        "dial_code": "+593",
        "code": "EC",
		"priority": 100
    },
    {
        "name": "Egypt",
        "dial_code": "+20",
        "code": "EG",
		"priority": 100
    },
    {
        "name": "El Salvador",
        "dial_code": "+503",
        "code": "SV",
		"priority": 100
    },
    {
        "name": "Equatorial Guinea",
        "dial_code": "+240",
        "code": "GQ",
		"priority": 100
    },
    {
        "name": "Eritrea",
        "dial_code": "+291",
        "code": "ER",
		"priority": 100
    },
    {
        "name": "Estonia",
        "dial_code": "+372",
        "code": "EE",
		"priority": 100
    },
    {
        "name": "Ethiopia",
        "dial_code": "+251",
        "code": "ET",
		"priority": 100
    },
    {
        "name": "Falkland Islands",
        "dial_code": "+500",
        "code": "FK",
		"priority": 100
    },
    {
        "name": "Faroe Islands",
        "dial_code": "+298",
        "code": "FO",
		"priority": 100
    },
    {
        "name": "Fiji",
        "dial_code": "+679",
        "code": "FJ",
		"priority": 100
    },
    {
        "name": "Finland",
        "dial_code": "+358",
        "code": "FI",
		"priority": 100
    },
    {
        "name": "France",
        "dial_code": "+33",
        "code": "FR",
		"priority": 100
    },
    {
        "name": "French Guiana",
        "dial_code": "+594",
        "code": "GF",
		"priority": 100
    },
    {
        "name": "French Polynesia",
        "dial_code": "+689",
        "code": "PF",
		"priority": 100
    },
    {
        "name": "Gabon",
        "dial_code": "+241",
        "code": "GA",
		"priority": 100
    },
    {
        "name": "Gambia",
        "dial_code": "+220",
        "code": "GM",
		"priority": 100
    },
    {
        "name": "Georgia",
        "dial_code": "+995",
        "code": "GE",
		"priority": 100
    },
    {
        "name": "Germany",
        "dial_code": "+49",
        "code": "DE",
		"priority": 100
    },
    {
        "name": "Ghana",
        "dial_code": "+233",
        "code": "GH",
		"priority": 100
    },
    {
        "name": "Gibraltar",
        "dial_code": "+350",
        "code": "GI",
		"priority": 100
    },
    {
        "name": "Greece",
        "dial_code": "+30",
        "code": "GR",
		"priority": 100
    },
    {
        "name": "Greenland",
        "dial_code": "+299",
        "code": "GL",
		"priority": 100
    },
    {
        "name": "Grenada",
        "dial_code": "+1473",
        "code": "GD",
		"priority": 100
    },
    {
        "name": "Guadeloupe",
        "dial_code": "+590",
        "code": "GP",
		"priority": 100
    },
    {
        "name": "Guam",
        "dial_code": "+1671",
        "code": "GU",
		"priority": 100
    },
    {
        "name": "Guatemala",
        "dial_code": "+502",
        "code": "GT",
		"priority": 100
    },
    {
        "name": "Guernsey",
        "dial_code": "+44",
        "code": "GG",
		"priority": 100
    },
    {
        "name": "Guinea",
        "dial_code": "+224",
        "code": "GN",
		"priority": 100
    },
    {
        "name": "Guinea-Bissau",
        "dial_code": "+245",
        "code": "GW",
		"priority": 100
    },
    {
        "name": "Guyana",
        "dial_code": "+595",
        "code": "GY",
		"priority": 100
    },
    {
        "name": "Haiti",
        "dial_code": "+509",
        "code": "HT",
		"priority": 100
    },
    {
        "name": "Holy See",
        "dial_code": "+379",
        "code": "VA",
		"priority": 100
    },
    {
        "name": "Honduras",
        "dial_code": "+504",
        "code": "HN",
		"priority": 100
    },    
    {
        "name": "Hungary",
        "dial_code": "+36",
        "code": "HU",
		"priority": 100
    },
    {
        "name": "Iceland",
        "dial_code": "+354",
        "code": "IS",
		"priority": 100
    },
    {
        "name": "India",
        "dial_code": "+91",
        "code": "IN",
		"priority": 100
    },
    {
        "name": "Indonesia",
        "dial_code": "+62",
        "code": "ID",
		"priority": 100
    },
    {
        "name": "Iran",
        "dial_code": "+98",
        "code": "IR",
		"priority": 100
    },
    {
        "name": "Iraq",
        "dial_code": "+964",
        "code": "IQ",
		"priority": 100
    },
    {
        "name": "Ireland",
        "dial_code": "+353",
        "code": "IE",
		"priority": 100
    },
    {
        "name": "Isle of Man",
        "dial_code": "+44",
        "code": "IM",
		"priority": 100
    },
    {
        "name": "Israel",
        "dial_code": "+972",
        "code": "IL",
		"priority": 100
    },
    {
        "name": "Italy",
        "dial_code": "+39",
        "code": "IT",
		"priority": 100
    },
    {
        "name": "Jamaica",
        "dial_code": "+1876",
        "code": "JM",
		"priority": 100
    },
    {
        "name": "Japan",
        "dial_code": "+81",
        "code": "JP",
		"priority": 100
    },
    {
        "name": "Jersey",
        "dial_code": "+44",
        "code": "JE",
		"priority": 100
    },
    {
        "name": "Jordan",
        "dial_code": "+962",
        "code": "JO",
		"priority": 100
    },
    {
        "name": "Kazakhstan",
        "dial_code": "+77",
        "code": "KZ",
		"priority": 100
    },
    {
        "name": "Kenya",
        "dial_code": "+254",
        "code": "KE",
		"priority": 100
    },
    {
        "name": "Kiribati",
        "dial_code": "+686",
        "code": "KI",
		"priority": 100
    },
    {
        "name": "Korea, DPR",
        "dial_code": "+850",
        "code": "KP",
		"priority": 100
    },   
    {
        "name": "Kuwait",
        "dial_code": "+965",
        "code": "KW",
		"priority": 100
    },
    {
        "name": "Kyrgyzstan",
        "dial_code": "+996",
        "code": "KG",
		"priority": 100
    },
    {
        "name": "Laos",
        "dial_code": "+856",
        "code": "LA",
		"priority": 100
    },
    {
        "name": "Latvia",
        "dial_code": "+371",
        "code": "LV",
		"priority": 100
    },
    {
        "name": "Lebanon",
        "dial_code": "+961",
        "code": "LB",
		"priority": 100
    },
    {
        "name": "Lesotho",
        "dial_code": "+266",
        "code": "LS",
		"priority": 100
    },
    {
        "name": "Liberia",
        "dial_code": "+231",
        "code": "LR",
		"priority": 100
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "dial_code": "+218",
        "code": "LY",
		"priority": 100
    },
    {
        "name": "Liechtenstein",
        "dial_code": "+423",
        "code": "LI",
		"priority": 100
    },
    {
        "name": "Lithuania",
        "dial_code": "+370",
        "code": "LT",
		"priority": 100
    },
    {
        "name": "Luxembourg",
        "dial_code": "+352",
        "code": "LU",
		"priority": 100
    },    
    {
        "name": "Macedonia",
        "dial_code": "+389",
        "code": "MK",
		"priority": 100
    },
    {
        "name": "Madagascar",
        "dial_code": "+261",
        "code": "MG",
		"priority": 100
    },
    {
        "name": "Malawi",
        "dial_code": "+265",
        "code": "MW",
		"priority": 100
    },
    {
        "name": "Malaysia",
        "dial_code": "+60",
        "code": "MY",
		"priority": 100
    },
    {
        "name": "Maldives",
        "dial_code": "+960",
        "code": "MV",
		"priority": 100
    },
    {
        "name": "Mali",
        "dial_code": "+223",
        "code": "ML",
		"priority": 100
    },
    {
        "name": "Malta",
        "dial_code": "+356",
        "code": "MT",
		"priority": 100
    },
    {
        "name": "Marshall Islands",
        "dial_code": "+692",
        "code": "MH",
		"priority": 100
    },
    {
        "name": "Martinique",
        "dial_code": "+596",
        "code": "MQ",
		"priority": 100
    },
    {
        "name": "Mauritania",
        "dial_code": "+222",
        "code": "MR",
		"priority": 100
    },
    {
        "name": "Mauritius",
        "dial_code": "+230",
        "code": "MU",
		"priority": 100
    },
    {
        "name": "Mayotte",
        "dial_code": "+262",
        "code": "YT",
		"priority": 100
    },
    {
        "name": "Mexico",
        "dial_code": "+52",
        "code": "MX",
		"priority": 100
    },
    {
        "name": "Micronesia",
        "dial_code": "+691",
        "code": "FM",
		"priority": 100
    },
    {
        "name": "Moldova",
        "dial_code": "+373",
        "code": "MD",
		"priority": 100
    },
    {
        "name": "Monaco",
        "dial_code": "+377",
        "code": "MC",
		"priority": 100
    },
    {
        "name": "Mongolia",
        "dial_code": "+976",
        "code": "MN",
		"priority": 100
    },
    {
        "name": "Montenegro",
        "dial_code": "+382",
        "code": "ME",
		"priority": 100
    },
    {
        "name": "Montserrat",
        "dial_code": "+1664",
        "code": "MS",
		"priority": 100
    },
    {
        "name": "Morocco",
        "dial_code": "+212",
        "code": "MA",
		"priority": 100
    },
    {
        "name": "Mozambique",
        "dial_code": "+258",
        "code": "MZ",
		"priority": 100
    },
    {
        "name": "Myanmar",
        "dial_code": "+95",
        "code": "MM",
		"priority": 100
    },
    {
        "name": "Namibia",
        "dial_code": "+264",
        "code": "NA",
		"priority": 100
    },
    {
        "name": "Nauru",
        "dial_code": "+674",
        "code": "NR",
		"priority": 100
    },
    {
        "name": "Nepal",
        "dial_code": "+977",
        "code": "NP",
		"priority": 100
    },
    {
        "name": "Netherlands",
        "dial_code": "+31",
        "code": "NL",
		"priority": 100
    },
    {
        "name": "Netherlands Antilles",
        "dial_code": "+599",
        "code": "AN",
		"priority": 100
    },
    {
        "name": "New Caledonia",
        "dial_code": "+687",
        "code": "NC",
		"priority": 100
    },
    {
        "name": "New Zealand",
        "dial_code": "+64",
        "code": "NZ",
		"priority": 100
    },
    {
        "name": "Nicaragua",
        "dial_code": "+505",
        "code": "NI",
		"priority": 100
    },
    {
        "name": "Niger",
        "dial_code": "+227",
        "code": "NE",
		"priority": 100
    },
    {
        "name": "Nigeria",
        "dial_code": "+234",
        "code": "NG",
		"priority": 100
    },
    {
        "name": "Niue",
        "dial_code": "+683",
        "code": "NU",
		"priority": 100
    },
    {
        "name": "Norfolk Island",
        "dial_code": "+672",
        "code": "NF",
		"priority": 100
    },
    {
        "name": "Northern Mariana",
        "dial_code": "+1670",
        "code": "MP",
		"priority": 100
    },
    {
        "name": "Norway",
        "dial_code": "+47",
        "code": "NO",
		"priority": 100
    },
    {
        "name": "Oman",
        "dial_code": "+968",
        "code": "OM",
		"priority": 100
    },
    {
        "name": "Pakistan",
        "dial_code": "+92",
        "code": "PK",
		"priority": 100
    },
    {
        "name": "Palau",
        "dial_code": "+680",
        "code": "PW",
		"priority": 100
    },
    {
        "name": "Palestinian Territory",
        "dial_code": "+970",
        "code": "PS",
		"priority": 100
    },
    {
        "name": "Panama",
        "dial_code": "+507",
        "code": "PA",
		"priority": 100
    },
    {
        "name": "Papua New Guinea",
        "dial_code": "+675",
        "code": "PG",
		"priority": 100
    },
    {
        "name": "Paraguay",
        "dial_code": "+595",
        "code": "PY",
		"priority": 100
    },
    {
        "name": "Peru",
        "dial_code": "+51",
        "code": "PE",
		"priority": 100
    },
    {
        "name": "Philippines",
        "dial_code": "+63",
        "code": "PH",
		"priority": 100
    },
    {
        "name": "Pitcairn",
        "dial_code": "+872",
        "code": "PN",
		"priority": 100
    },
    {
        "name": "Poland",
        "dial_code": "+48",
        "code": "PL",
		"priority": 100
    },
    {
        "name": "Portugal",
        "dial_code": "+351",
        "code": "PT",
		"priority": 100
    },
    {
        "name": "Puerto Rico",
        "dial_code": "+1939",
        "code": "PR",
		"priority": 100
    },
    {
        "name": "Qatar",
        "dial_code": "+974",
        "code": "QA",
		"priority": 100
    },
    {
        "name": "Romania",
        "dial_code": "+40",
        "code": "RO",
		"priority": 100
    },
    {
        "name": "Russia",
        "dial_code": "+7",
        "code": "RU",
		"priority": 100
    },
    {
        "name": "Rwanda",
        "dial_code": "+250",
        "code": "RW",
		"priority": 100
    },
    {
        "name": "Reunion",
        "dial_code": "+262",
        "code": "RE",
		"priority": 100
    },
    {
        "name": "Saint Barthelemy",
        "dial_code": "+590",
        "code": "BL",
		"priority": 100
    },
    {
        "name": "Saint Helena",
        "dial_code": "+290",
        "code": "SH",
		"priority": 100
    },
    {
        "name": "Saint Kitts&Nevis",
        "dial_code": "+1869",
        "code": "KN",
		"priority": 100
    },
    {
        "name": "Saint Lucia",
        "dial_code": "+1758",
        "code": "LC",
		"priority": 100
    },
    {
        "name": "Saint Martin",
        "dial_code": "+590",
        "code": "MF",
		"priority": 100
    },
    {
        "name": "Saint Pierre&Miquelon",
        "dial_code": "+508",
        "code": "PM",
		"priority": 100
    },
    {
        "name": "Saint Vincent",
        "dial_code": "+1784",
        "code": "VC",
		"priority": 100
    },
    {
        "name": "Samoa",
        "dial_code": "+685",
        "code": "WS",
		"priority": 100
    },
    {
        "name": "San Marino",
        "dial_code": "+378",
        "code": "SM",
		"priority": 100
    },
    {
        "name": "Sao Tome&Principe",
        "dial_code": "+239",
        "code": "ST",
		"priority": 100
    },
    {
        "name": "Saudi Arabia",
        "dial_code": "+966",
        "code": "SA",
		"priority": 100
    },
    {
        "name": "Senegal",
        "dial_code": "+221",
        "code": "SN",
		"priority": 100
    },
    {
        "name": "Serbia",
        "dial_code": "+381",
        "code": "RS",
		"priority": 100
    },
    {
        "name": "Seychelles",
        "dial_code": "+248",
        "code": "SC",
		"priority": 100
    },
    {
        "name": "Sierra Leone",
        "dial_code": "+232",
        "code": "SL",
		"priority": 100
    },
    {
        "name": "Singapore",
        "dial_code": "+65",
        "code": "SG",
		"priority": 100
    },
    {
        "name": "Slovakia",
        "dial_code": "+421",
        "code": "SK",
		"priority": 100
    },
    {
        "name": "Slovenia",
        "dial_code": "+386",
        "code": "SI",
		"priority": 100
    },
    {
        "name": "Solomon Islands",
        "dial_code": "+677",
        "code": "SB",
		"priority": 100
    },
    {
        "name": "Somalia",
        "dial_code": "+252",
        "code": "SO",
		"priority": 100
    },
    {
        "name": "South Africa",
        "dial_code": "+27",
        "code": "ZA",
		"priority": 100
    },
    {
        "name": "South Sudan",
        "dial_code": "+211",
        "code": "SS",
		"priority": 100
    },
    {
        "name": "South Georgia",
        "dial_code": "+500",
        "code": "GS",
		"priority": 100
    },
    {
        "name": "Spain",
        "dial_code": "+34",
        "code": "ES",
		"priority": 100
    },
    {
        "name": "Sri Lanka",
        "dial_code": "+94",
        "code": "LK",
		"priority": 100
    },
    {
        "name": "Sudan",
        "dial_code": "+249",
        "code": "SD",
		"priority": 100
    },
    {
        "name": "Suriname",
        "dial_code": "+597",
        "code": "SR",
		"priority": 100
    },
    {
        "name": "Svalbard&Jan Mayen",
        "dial_code": "+47",
        "code": "SJ",
		"priority": 100
    },
    {
        "name": "Swaziland",
        "dial_code": "+268",
        "code": "SZ",
		"priority": 100
    },
    {
        "name": "Sweden",
        "dial_code": "+46",
        "code": "SE",
		"priority": 100
    },
    {
        "name": "Switzerland",
        "dial_code": "+41",
        "code": "CH",
		"priority": 100
    },
    {
        "name": "Syrian Arab Republic",
        "dial_code": "+963",
        "code": "SY",
		"priority": 100
    },    
    {
        "name": "Tajikistan",
        "dial_code": "+992",
        "code": "TJ",
		"priority": 100
    },
    {
        "name": "Tanzania",
        "dial_code": "+255",
        "code": "TZ",
		"priority": 100
    },
    {
        "name": "Thailand",
        "dial_code": "+66",
        "code": "TH",
		"priority": 100
    },
    {
        "name": "Timor-Leste",
        "dial_code": "+670",
        "code": "TL",
		"priority": 100
    },
    {
        "name": "Togo",
        "dial_code": "+228",
        "code": "TG",
		"priority": 100
    },
    {
        "name": "Tokelau",
        "dial_code": "+690",
        "code": "TK",
		"priority": 100
    },
    {
        "name": "Tonga",
        "dial_code": "+676",
        "code": "TO",
		"priority": 100
    },
    {
        "name": "Trinidad&Tobago",
        "dial_code": "+1868",
        "code": "TT",
		"priority": 100
    },
    {
        "name": "Tunisia",
        "dial_code": "+216",
        "code": "TN",
		"priority": 100
    },
    {
        "name": "Turkey",
        "dial_code": "+90",
        "code": "TR",
		"priority": 100
    },
    {
        "name": "Turkmenistan",
        "dial_code": "+993",
        "code": "TM",
		"priority": 100
    },
    {
        "name": "Turks&Caicos Islands",
        "dial_code": "+1649",
        "code": "TC",
		"priority": 100
    },
    {
        "name": "Tuvalu",
        "dial_code": "+688",
        "code": "TV",
		"priority": 100
    },
    {
        "name": "Uganda",
        "dial_code": "+256",
        "code": "UG",
		"priority": 100
    },
    {
        "name": "Ukraine",
        "dial_code": "+380",
        "code": "UA",
		"priority": 100
    },
    {
        "name": "United Arab Emirates",
        "dial_code": "+971",
        "code": "AE",
		"priority": 100
    },
    {
        "name": "United Kingdom",
        "dial_code": "+44",
        "code": "GB",
		"priority": 100
    },    
    {
        "name": "Uruguay",
        "dial_code": "+598",
        "code": "UY",
		"priority": 100
    },
    {
        "name": "Uzbekistan",
        "dial_code": "+998",
        "code": "UZ",
		"priority": 100
    },
    {
        "name": "Vanuatu",
        "dial_code": "+678",
        "code": "VU",
		"priority": 100
    },
    {
        "name": "Venezuela",
        "dial_code": "+58",
        "code": "VE",
		"priority": 100
    },   
    {
        "name": "Virgin Islands, British",
        "dial_code": "+1284",
        "code": "VG",
		"priority": 100
    },
    {
        "name": "Virgin Islands, U.S.",
        "dial_code": "+1340",
        "code": "VI",
		"priority": 100
    },
    {
        "name": "Wallis&Futuna",
        "dial_code": "+681",
        "code": "WF",
		"priority": 100
    },
    {
        "name": "Yemen",
        "dial_code": "+967",
        "code": "YE",
		"priority": 100
    },
    {
        "name": "Zambia",
        "dial_code": "+260",
        "code": "ZM",
		"priority": 100
    },
    {
        "name": "Zimbabwe",
        "dial_code": "+263",
        "code": "ZW",
		"priority": 100
    },
];
 
export default arr;